import React from "react";
import { motion } from "framer-motion";
import indexGirl from "@/assets/images/index/indexGirl.png";

const TopAiHelloCard = () => {
  return (
    <div className='h-56 -z-0'>
      <div className='h-[100vh]  p-4 bg-gradient-to-b from-indigo-500 to-indigo-500/40'>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 1,
            scale: { type: "spring", visualDuration: 2, bounce: 0.5 },
          }}
          className=' text-white/30 text-center text-7xl font-bold'
        >
          AICOACH
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.4,
            scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
          }}
          className='mt-6 text-white/90 text-left text-2xl font-bold'
        >
          HI,我是授课小A
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 0.4,
            duration: 1,
            scale: { type: "spring", visualDuration: 2, bounce: 0.5 },
          }}
          className='text-white/80 text-left mt-2 text-sl font-bold'
        >
          你的智能对联助手
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 0.8,
            duration: 1,
            scale: { type: "spring", visualDuration: 2, bounce: 0.5 },
          }}
          className='absolute top-24 right-12  w-32 h-32 '
        >
          <img src={indexGirl} alt="indexGirl" className="w-full h-full" />
        </motion.div>
      </div>
    </div>
  );
};

export default TopAiHelloCard;
